import React, { useEffect, useState } from 'react';
import { Loader2Icon } from 'lucide-react';
import { fetchJobs, type Job } from '../data/jobsFeed';
import { JobCard } from './JobCard';
type Status = 'loading' | 'success' | 'error';
export function JobsSection() {
  const [status, setStatus] = useState<Status>('loading');
  const [jobs, setJobs] = useState<Job[]>([]);
  useEffect(() => {
    let active = true;
    // Fetch fresh on every page load (no indefinite caching) so new postings
    // and closures on the WordPress side appear without a rebuild.
    async function load() {
      setStatus('loading');
      try {
        const result = await fetchJobs();
        if (!active) return;
        setJobs(result);
        setStatus('success');
      } catch {
        if (!active) return;
        setStatus('error');
      }
    }
    load();
    return () => {
      active = false;
    };
  }, []);
  const unavailable = status === 'error' || status === 'success' && jobs.length === 0;
  return <section className="section-white" data-id="element-193" data-mp="2kpfnqyw2658q">
      <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-194" data-mp="2kqicp19tlxm0">
        <h2 className="text-3xl font-bold text-center mb-4" data-id="element-195" data-mp="2gonc5yzpro9a">
          Current Opportunities
        </h2>
        <div className="h-1 w-16 bg-nrs-orange mx-auto rounded-full mb-6" data-id="element-196" data-mp="2ufs5ykgehmbp"></div>
        <p className="text-lg text-nrs-gray text-center mb-10 max-w-2xl mx-auto" data-id="element-197" data-mp="2pp21rajpnpil">
          Explore our current openings. Expand any role for the full
          description, requirements, certifications, and salary range.
        </p>

        {status === 'loading' && <div className="flex items-center justify-center gap-3 text-gray-500 text-sm py-12" data-id="element-198" data-mp="2zebtgpan7666">
            <Loader2Icon className="h-5 w-5 animate-spin text-nrs-blue" data-id="element-199" data-mp="3ddl99nuxry9m" />
            Loading current openings…
          </div>}

        {unavailable && <div className="max-w-xl mx-auto text-center bg-nrs-light border border-gray-200 rounded-xl p-8" data-id="element-200" data-mp="1j03gnmfocb7q">
            <p className="text-nrs-navy font-semibold mb-2" data-id="element-201" data-mp="1e1s6tbpdq0pi">
              Current openings are temporarily unavailable — please check back
              soon.
            </p>
            <p className="text-gray-600 text-sm" data-id="element-202" data-mp="3j2l699q49x5k">
              In the meantime, you can always send your resume to{' '}
              <a href="mailto:careers@newriversystems.com" className="text-nrs-blue font-semibold hover:text-nrs-orange transition-colors" data-id="element-203" data-mp="3o166h95dcgu0">
                careers@newriversystems.com
              </a>
              .
            </p>
          </div>}

        {status === 'success' && jobs.length > 0 && <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-204" data-mp="5vt8nt2z3jk7">
            {jobs.map(job => <JobCard key={job.id} job={job} data-id="element-205" data-mp="am9kj8r5ax4g" />)}
          </div>}
      </div>
    </section>;
}